module.exports = __webpack_public_path__ + "static/media/selectlogo.71a9196d.png";